import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { truncate } from 'utils/string-utils';
import { PATH_CLIENT_EDIT, PATH_CLIENT_FACILITY_EDIT } from 'routing/path'
import PageHeader from 'components/page-header'
import ClientFacilitySearchFilter from 'components/search-filters/client-facility-search-filter'
import Table from 'components/table'
import { useGetFacilitiesQuery } from 'actions/client/client-facility-api';
import { translationApi  } from 'actions/translation-api';
import { changePage  } from 'store/client/slice.facility-list-filter';

const ClientFacilityList = () => {
	const dispatch = useDispatch();
	const params = useParams();
	const clientIdString = params.id;

	const facilityListFilter = useSelector(state => state.facilityListFilter);
	const { data: facilityList } = useGetFacilitiesQuery(facilityListFilter, { refetchOnMountOrArgChange: true });
	const translations = useSelector(translationApi.endpoints.getTranslations.select()).data ?? {};

	const changeFacilityListPage = (filterChange) => {
        dispatch(changePage(filterChange.page));
	}

	const getPageHeader = () => {
		let title = translations.clientFacilityList;
		const breadcrumbsCurrentPage = translations.clientFacilityList;
		let breadcrumbs = [];
		if (clientIdString && facilityList?.clientName) {
			title = `${facilityList.clientName} - ${translations.clientFacilityList}`;
			breadcrumbs = [
				{ name: `${translations.client} ${facilityList.clientName}`, link: PATH_CLIENT_EDIT + clientIdString }
			]
		}

		return <PageHeader title={title} breadcrumbs={breadcrumbs} breadcrumbsCurrentPage={breadcrumbsCurrentPage} />
	}

	const pageHeader = getPageHeader();
	const headers = [translations.clientNumberShort, translations.clientName, translations.clientFacilityName, translations.address];
	let rows = [];
	if (facilityList && facilityList.clientFacilities) {
		rows = facilityList.clientFacilities.map(function (facility) {
			return {
				link: PATH_CLIENT_FACILITY_EDIT + facility.clientFacilityId,
				columns: [
					facility.clientId.toString().padStart(4, '0'),
					truncate(facility.clientName, 30),
					facility.name,
					`${facility.address.street}, ${facility.address.postalCode} ${facility.address.city}`
				],
				tooltips: [null, facility.clientName, null, null]
			}
		});
	}

	return (
		<div>
			{pageHeader}
			<ClientFacilitySearchFilter />
			<Table fetchList={changeFacilityListPage} headers={headers} rows={rows} pagination={facilityList?.pagination} translations={translations} />
		</div>
	);
}

export default ClientFacilityList
